export const es = {
  save: "Guardar",
  update: "Actualizar",
  accept: "Aceptar",
  cancel: "Cancelar",
  close: "Cerrar",
  add: "Añadir",
  check: "Comprobar",
  certificate: "Certificado",
  certificates: "Certificados",
  certification: "Certificación",
  certifications: "Certificaciones",
  "valid-certificate": "Certificado válido",
  date: "Fecha",
  "valid-thru": "Válido hasta",
  dashboard: "Página de inicio",
  error: "Página de error",
  forms: "Formularios",
  notifications: "Notificaciones",
  "my-profile": "Mi perfil",
  "my-documents": "Mis documentos",
  "no-documents-available": "No hay documentos disponibles",
  "training-materials": "Material de formación",
  "open-in-webviewer": "Abrir en el visor",
  expired: "Caducado",
  "expired-training-materials": "Material de formación caducado",
  "register-headline": "Registro",
  register: "Registrarse",
  search: "Búsqueda",
  print: "Imprimir",
  "printed-via": "Impreso a través de www.evalcard.com",
  settings: {
    label: "Ajustes",
    publicProfile: {
      showEmailInPublic: "Mostrar el correo electrónico",
      showPhoneInPublic: "Mostrar el número de teléfono",
      showAddressInPublic: "Mostrar la dirección",
    },
  },
  tables: "Tablas",
  tabs: "Pestañas",
  myeval: "EvalCard",
  "eval-id": "Eval-ID",
  id: "ID",
  timeline: "Cronología",
  typography: "Tipografía",
  admin: "Administrador",
  user: "Usuario",
  templateAuthor: "Creador global de plantillas",
  users: "Usuario",
  "user-profile": "Perfil de usuario",
  "company-name": "Nombre de la empresa",
  "company-logo": "Logotipo de la empresa",
  "company-profile": "Perfil de la empresa",
  "company-profile-admin": "Perfil de la empresa",
  "company-invitation": "Invitación de la empresa",
  "invitation-sent": "Invitación enviada",
  "new-password": "Nueva contraseña",
  "generate-new-password": "Generar una nueva contraseña",
  "current-password": "Contraseña actual",
  "repeat-password": "Repetir la contraseña",
  "password-successfully-changed": "Su contraseña se ha cambiado correctamente",
  "password-reset": "Restablecer la contraseña",
  "edit-user-profile": "Editar el perfil de usuario",
  "edit-user-profile-admin": "Editar el perfil de usuario",
  system: "Sistema",
  widgets: "Widgets",
  wizard: "Asistente",
  logout: "Cerrar sesión",
  login: "Iniciar sesión",
  companies: "Empresas",
  "my-company": "Mi empresa",
  "leave-company": "Abandonar la empresa",
  "delete-company": "Eliminar la empresa",
  company: "Empresa",
  uid: "NIF/número fiscal",
  employees: "Empleados",
  employee: "Empleado/a",
  companyadmin: "Admin",
  evalclient: "Responsable de EVAL",
  coworker: "Empleados",
  "coworker-profile": "Perfil del empleado",
  "search-user": "Buscar usuario",
  "search-user-placeholder": "Nombre, correo electrónico, EVAL-ID",
  trainer: "Formador",
  "training-level": "Nivel de formación",
  gtp: "GTP",
  authorityAdmin: "Admin",
  trainerRO: "Formador (solo lectura)",
  authorityAdminRO: "Admin (solo lectura)",
  protocols: "Informes de inspección",
  report: "Informe de inspección",
  "new-report": "Nuevo informe de inspección",
  "all-reports": "Todos los informes de inspección",
  "all-assets": "Todos los objetos",
  "report-from": "Informe de inspección del",
  "report-details": "Detalles del informe de inspección",
  data: "Datos",
  info: "Información",
  attachment: "Adjunto",
  contact: "Contacto",
  continue: "Continuar",
  start: "Iniciar",
  summary: "Resumen",
  vin: "VIN",
  "licence-plate": "Matrícula",
  owner: "Propietario",
  vehicles: "Vehículos",
  vehicle: "Vehículo",
  "vehicle-details": "Detalles del vehículo",
  companyVehicle: "Vehículo de la empresa",
  valid: "Correcto",
  invalid: "Incorrecto",
  tester: "Inspector",
  "vehicles-admin": "Vehículos",
  "create-company-vehicle": "Crear vehículo",
  "select-vehicle": "Selección de vehículo",
  "my-vehicles": "Mis vehículos",
  "my-vehicle": "Mi vehículo",
  asset: "Objeto",
  assets: "Objetos",
  "serial-number": "Número de serie",
  "asset-type": "Tipo de objeto",
  "asset-types": "Tipos de objeto",
  "calibration-valid-thru": "Calibración válida hasta",
  "requires-calibration": "Debe calibrarse periódicamente",
  "calibration-warning-days": "Plazo de aviso (días)",
  "gtp-classes": "Clases GTP",
  code: "Código",
  subtype: "Subtipo",
  icon: "Icono",
  qualification: "Cualificación (HTML)",
  gtpIcon: {
    car: "Coche",
    forklift: "Carretilla elevadora",
    gauge: "Tacómetro",
    "train-front": "Tren",
    ship: "Barco",
    plane: "Avión",
    settings: "Engranaje",
    wrench: "Llave fija",
  },
  photos: "Fotos",
  "new-vehicle": "Nuevo vehículo",
  manufacturer: "Fabricante",
  "no-manufacturer": "(Ningún fabricante)",
  "no-vehicle": "(Ningún vehículo)",
  "vehicle-manufacturer": "Fabricante del vehículo",
  "create-vehicle": "Crear vehículo",
  "create-vehicle-manufacturer": "Crear fabricante de vehículos",
  "construction-year": "Año de fabricación",
  "change-password": "Cambiar la contraseña",
  roles: "Permisos",
  actions: "Acciones",
  action: "Acción",
  profile: "Perfil",
  email: "Correo electrónico",
  basic: "Básico",
  special: "Especial",
  breakdown: "Distribución",
  "click-for-details": "Haga clic para ver los detalles",
  rights: "Derechos",
  details: "Detalles",
  information: "Información",
  "details-and-information": "Detalles e información",
  name: "Nombre",
  namename: "Denominación",
  firstname: "Nombre",
  lastname: "Apellido",
  fullname: "Nombre completo",
  password: "Contraseña",
  street: "Calle",
  number: "Número",
  city: "Ciudad",
  country: "País",
  "forgot-password": "¿Ha olvidado su contraseña?",
  "recover-password": "Restablecer la contraseña",
  back: "Atrás",
  "back-to-login": "Volver al inicio de sesión",
  "go-to-login": "Ir al inicio de sesión",
  "choose-picture": "Seleccionar imagen",
  "choose-logo": "Seleccionar logotipo",
  "image-format-not-supported": "Este formato de imagen no es compatible. Seleccione una imagen JPG o PNG.",
  "send-invitation": "Enviar invitación",
  zipcode: "Código postal",
  previous: "Atrás",
  abort: "Cancelar",
  "i-understand": "Entendido",
  no: "No",
  yes: "Sí",
  inputs: "Entradas",
  "user-activated": "Activado",
  "user-not-activated": "El usuario aún no está activado",
  "user-did-not-receive-activation-email": "El usuario aún no ha recibido el correo de activación",
  "allow-coworkers-to-show-on-profile": "Mostrar en el perfil de usuario de los empleados:",
  "resend-activation-email": "Solicitar enlace de activación",
  "coworker-education-status": "Estado de formación de los empleados",
  card: "Tarjeta de visita",
  "certification-authority": "Organismo de certificación",
  "certification-authority-admin": "Organismo de certificación",
  "certification-authorities": "Organismos de certificación",
  "delete-certification-authority": "Eliminar el organismo de certificación",
  "certificate-templates": "Plantillas de certificado",
  "certificate-template": "Plantilla de certificado",
  "creating-certificates": "Se están creando los certificados...",
  "issue-certificate": "Emitir el certificado",
  "issue-date": "Fecha de emisión",
  "due-date": "Fecha de caducidad",
  "issued-on": "Emitido el",
  "issued-by": "Emitido por",
  author: "Emisor",
  "certificate-name": "Nombre del certificado",
  "certificate-number": "Número del certificado",
  "born-on": "nacido el",
  mileage: "Kilometraje",
  public: "Público",
  "back-to-the-app": "Volver a la aplicación",
  "can-create-reports": "Informes de inspección posibles",
  "temporary-certification": "Certificación temporal",
  "temporary-days-valid": "Válido durante (días)",
  "valid-for": "Válido durante (años)",
  "pdf-template": "Plantilla PDF",
  "pdf-certificate": "Certificado PDF propio",
  "show-pdf-certificate": "Certificado en PDF",
  standards: "Normas (HTML)",
  "text-block": "Texto tras las normas (HTML)",
  "text-block-hint": "Marcador de posición: {placeholders} — qualifikationen inserta los textos de las clases GTP asignadas",
  "digital-signature": "Firma digital",
  eval0: "HV-0",
  eval1: "HV-1",
  eval2: "HV-2",
  eval3: "HV-3",
  eval4: "HV-4",
  evalc: "HV-C",
  evalbex: "HV-BEX",
  evall: "HV-L",
  evalf: "HV-F",
  evalpro: "HV-Pro",
  evals: "HV-S",
  evalt: "HV-T",
  sonstige: "Otros",
  others: "Otro",
  levelGroupBase: "Niveles básicos",
  levelGroupSpecial: "Especial: requiere formación previa",
  levelGroupSpecialTraining: "Formaciones especiales sin requisitos",
  level: "Nivel",
  type: "Tipo",
  "training-data": "Material de formación",
  "training-info": "Información sobre la formación",
  "generated-password": "Contraseña generada",
  "invitation-email": "Correo de invitación",
  document: "Documento",
  documents: "Documentos",
  active: "activo",
  inactive: "inactivo",
  all: "TODOS",
  "all-sort": "Todos/Ordenar",
  "created-on": "Creado el",
  result: "Resultado",
  results: "Resultados",
  "try-again": "Intentar de nuevo",
  status: "Estado",
  published: "Publicado",
  draft: "Borrador",
  sn: "SN",
  "something-went-wrong": "Algo ha ido mal",
  "checking-prerequisites": "Se están comprobando los requisitos...",
  "prerequisite-warning-title": "Requisitos que faltan",
  "missing-prerequisites": "Requiere al menos:",
  "info-signs": "Señales indicativas",
  danger: "Atención",
  "hazardous-voltage": "Tensión peligrosa",
  "no-access-1": "A personas no autorizadas",
  "no-access-2": "Entrada prohibida",
  "access-only-by": "Acceso solo por",
  "company-logo-is-missing": "Falta el logotipo de la empresa",
  download: "Descargar",
  "access-denied": "Entrada prohibida",
  "dont-switch-on": "No conectar",
  "hv-system": "Sistema de alta tensión",
  disconnected: "Consignado",
  "disconnected-by": "Consignado por",
  "works-in-progress": "Trabajos en curso",
  forum: "Foro EV",
  topic: "Tema",
  topics: "Temas",
  title: "Título",
  created: "Creado",
  "created-by": "Creado por",
  "is-global": "Plantilla global",
  "templateauthor-requires-report-permission": "Solo los usuarios que pueden crear informes pueden convertirse en creadores globales de plantillas.",
  from: "de",
  answers: "Respuestas",
  "post-answer": "Publicar respuesta",
  "edit-answer": "Editar respuesta",
  "new-topic": "Nuevo tema",
  "edit-topic": "Editar tema",
  "create-new-topic": "Crear nuevo tema",
  "last-answer": "Última respuesta",
  "view-all": "Ver todo",
  attachments: "Adjuntos",
  "link-url": "Enlace (URL)",
  "newest-topics": "Temas más recientes",
  "privacy-policy": "Protección de datos",
  "new-files": "Archivos nuevos",
  "existing-files": "Archivos existentes",
  courses: "Cursos",
  location: "Ubicación",
  loading: "Cargar",
  "view-details": "Mostrar detalles",
  "no-courses-found": "No se han encontrado cursos",
  "no-courses-assigned": "No hay cursos disponibles",
  dialog: {
    "are-you-sure": "¿Está seguro?",
    "an-unexpected-error-occured": "Se ha producido un error inesperado. Inténtelo de nuevo más tarde",
    "do-you-really-want-the-user-to": "¿Desea realmente el usuario",
    "do-you-really-want-the-invitation-to": "¿Desea realmente la invitación",
    delete: "eliminar",
    "delete-user": "Eliminar usuario",
    "delete-topic": "Eliminar tema",
    "delete-topic-answer": "Eliminar respuesta",
    "remove-user": "Quitar usuario",
    "remove-trainer": "Quitar inspector",
    "remove-from-company": "¿quitar de la empresa?",
    "remove-from-certification-authority": "¿quitar del organismo de certificación?",
    "create-user": "Crear usuario",
    "the-most-important-information": "La información más importante",
    "create-company": "Crear empresa",
    "the-most-important-information-about-the-company": "La información más importante de la empresa",
    "create-company-vehicle": "Crear vehículo de la empresa",
    "the-most-important-information-about-the-vehicle": "La información más importante del vehículo",
    "the-most-important-information-about-the-asset": "La información más importante del objeto",
    "create-report": "Crear informe de inspección",
    "where-is-the-company-located": "¿Dónde se encuentra la empresa?",
    "where-is-the-certification-authority-located": "¿Dónde se encuentra el organismo de certificación?",
    "whats-the-role-of-the-person": "¿Qué función tiene la persona?",
    "where-does-the-person-live": "¿Dónde vive la persona?",
    "further-details": "Más detalles",
    "register-successfull": "¡El registro se ha realizado correctamente! En breve recibirá un correo electrónico con su contraseña.",
    "great-you-will-receive-an-email": "En breve recibirá un correo electrónico con el que podrá restablecer su contraseña",
    "this-should-not-take-longer-than": "Esto no debería tardar más de 5 minutos. Si tarda más, consulte también su carpeta de spam.",
    "i-agree": "Acepto las",
    "terms-and-conditions": "condiciones generales",
    "hereby-i-agree": "Por la presente acepto que EvalCert GmbH pueda utilizar mis datos personales con el fin de emitir una tarjeta EVAL y para el registro de usuarios en my.evalcard.com.",
    "further-i-agree-to": "Además, acepto que EvalCert GmbH pueda informarme por boletín electrónico sobre novedades en el ámbito de la alta tensión (nuevas formaciones, novedades de productos o eventos), hasta su revocación.",
    "allowed-to-be-used": " (.de o .com) puede utilizarse.",
    "refusal-is-allways": "La revocación es posible en cualquier momento por correo electrónico a",
    possible: "posible.",
    "the-e-val-card-is-the": "La tarjeta EVAL es el justificante de cualificación en formato tarjeta. La abreviatura EVAL significa Electric Vehicle Access License",
    "complete-user-data": "Completar los datos de usuario",
    "complete-user-data-info": "Para poder ayudarle de la mejor manera posible y ponerle a disposición todas las funciones, necesitamos un perfil de usuario completamente rellenado",
    "your-password-reset-is-being-processed": "Su contraseña se está restableciendo en este momento. Si tarda más de unos minutos, inténtelo de nuevo.",
    "your-password-has-been-sent": "Su contraseña se ha restablecido correctamente. En unos minutos debería recibir un correo electrónico con su nueva contraseña.",
    "if-it-did-not-work": "Consulte también su carpeta de spam. Si no ha recibido su nueva contraseña en 5-10 minutos, inténtelo de nuevo.",
    "user-not-authorized": "Correo electrónico y/o contraseña incorrectos",
    "user-not-activated": "Este usuario aún no está activado. Utilice el enlace del correo de activación",
    "user-or-password-wrong": "El correo electrónico o la contraseña son incorrectos",
    "users-selected": "Usuario seleccionado",
    "user-profile-update-successfull": "El perfil de usuario se ha guardado correctamente",
    "user-profile-update-failed": "No se ha podido guardar el perfil de usuario. Inténtelo de nuevo más tarde.",
    "do-you-really-want-to-leave-the-company": "¿Desea realmente abandonar la empresa?",
    "in-order-to-accept-a-company-invitation": "Para poder aceptar una invitación de empresa, debe estar ya registrado y con la sesión iniciada",
    "do-you-really-want-to-join-the-company": "¿Está seguro de que desea unirse a la empresa?",
    "if-you-are-already-in-a-company-you-will-be-removed": "Si ya pertenece a una empresa, será eliminado de ella",
    "you-are-not-a-member-of-a-company": "Actualmente no está asignado a ninguna empresa. En cuanto sea miembro de una empresa, podrá utilizar esta página.",
    "you-are-not-a-member-of-a-certification-authority": "Actualmente no está asignado a ningún organismo de certificación",
    "do-you-really-want-the-company-to": "¿Desea realmente la empresa",
    "company-created-successfully": "La empresa se ha creado correctamente",
    "company-already-exists": "Ya existe una empresa con este nombre o este correo electrónico. Por eso no se ha podido crear la empresa",
    "vehicle-save-successfully": "El vehículo se ha guardado correctamente",
    "asset-save-successfully": "El objeto se ha guardado correctamente",
    "gtp-class-save-successfully": "La clase GTP se ha guardado correctamente",
    "gtp-class-already-exists": "Ya existe una clase GTP con este código",
    "do-you-really-want-the-gtp-class-to": "¿Desea realmente la clase GTP",
    "asset-type-save-successfully": "El tipo de objeto se ha guardado correctamente",
    "do-you-really-want-the-asset-type-to": "¿Desea realmente el tipo de objeto",
    "vehicle-already-exists": "Ya existe un vehículo con este VIN y propietario",
    "vehicle-accepted": "El vehículo se ha incorporado al sistema",
    "vehicle-manufacturer-accepted": "El fabricante del vehículo se ha incorporado al sistema",
    "report-save-successfully": "El informe de inspección se ha guardado correctamente",
    "report-already-exists": "Ya existe un informe de inspección con este nombre o tipo en esta empresa.",
    "create-company-failed": "No se ha podido crear la empresa. Inténtelo de nuevo más tarde.",
    "save-user-success": "El usuario se ha guardado correctamente",
    "user-already-exists": "Ya existe un usuario con este correo electrónico o este nombre.",
    "save-company-success": "La empresa se ha guardado correctamente",
    "save-company-failed": "No se ha podido guardar la empresa. Inténtelo de nuevo más tarde.",
    "save-changes-success": "Los cambios se han guardado correctamente",
    "do-you-really-want-the-vehicle-to": "¿Desea realmente el vehículo",
    "do-you-really-want-the-asset-to": "¿Desea realmente el objeto",
    "do-you-really-want-the-report-to": "¿Desea realmente el informe de inspección",
    "do-you-really-want-the-certificate-to": "¿Desea realmente el certificado",
    "do-you-really-want-the-vehicle-manufacturer-to": "¿Desea realmente el fabricante del vehículo",
    "save-vehicle-manufacturer-success": "El fabricante del vehículo se ha guardado correctamente",
    "save-vehicle-manufacturer-error": "No se ha podido guardar el fabricante del vehículo",
    "save-vehicle-success": "El vehículo se ha guardado correctamente",
    "save-vehicle-error": "No se ha podido guardar el vehículo",
    "who-works-in-the-company": "¿Quién trabaja en la empresa?",
    "who-works-in-the-certification-authority": "¿Quién trabaja en el organismo de certificación?",
    "your-company-has-been-created-check-your-emails": "¡Su empresa ha sido creada! En breve debería recibir un correo electrónico con el que podrá activar su empresa. Consulte, si es necesario, su carpeta de spam.",
    "if-you-havent-received-an-email-yet": "Si en 5 minutos aún no ha recibido ningún correo electrónico, puede solicitarlo aquí de nuevo.",
    "if-this-did-not-work": "Si aun así no ha funcionado, también puede abandonar su empresa y crear una nueva.",
    "is-already-in-a-company": "ya pertenece a una empresa",
    "invite-user-already-exists-in-company": "El usuario con este correo electrónico ya está en la empresa",
    "invite-user-already-exists-in-other-company": "El usuario con este correo electrónico ya está en otra empresa",
    "create-certification-authority": "Crear organismo de certificación",
    "certification-authority-save-successfully": "El organismo de certificación se ha guardado correctamente",
    "certification-authority-already-exists": "Ya existe un organismo de certificación con este correo electrónico o este nombre.",
    "certificate-already-exists": "Ya existe una certificación con este nombre para este usuario.",
    "certificate-save-successfully": "La certificación se ha guardado correctamente",
    "do-you-really-want-to-delete": "¿Desea realmente eliminar",
    "delete-report-template": "Eliminar plantilla",
    "create-certificate": "Crear certificado",
    "create-certificate-template": "Crear plantilla de certificado",
    "who-gets-the-certificate": "¿A quién se debe emitir el certificado",
    "user-with-this-eval-id-was-not-found": "No se ha encontrado ningún usuario con este Eval-ID",
    "you-can-only-add-reports-if-you-have-company-vehicles": "Solo puede crear un informe si posee vehículos de la empresa",
    "you-can-only-input-eu-numbers": "Solo se admiten números en formato UE",
    "you-dont-have-the-rights": "Sin permisos para esta área",
    "certificate-template-save-success": "La plantilla de certificado se ha guardado correctamente",
    "certificate-template-sort-save-success": "El orden de las plantillas de certificado se ha guardado correctamente",
    "your-certification-authority-does-not-have-templates": "Cree primero una plantilla de certificado para poder emitir certificados",
    "this-company-is-not-yet-activated": "Esta empresa aún no ha sido activada. El enlace de activación se ha enviado a la dirección de correo electrónico de la empresa",
    "welcome-to-the-dashboard": "¡Bienvenido a la página de inicio! Actualmente no está asignado a ninguna empresa. En cuanto sea miembro de una empresa, podrá ver aquí un resumen de sus protocolos",
    "valid-certificates": "Certificados válidos",
    "certificates-last-30-days": "Certificados: últimos 30 días",
    "certificates-on": "Certificados el",
    "reports-last-30-days": "Informes: últimos 30 días",
    "no-data-available": "Todavía no hay datos disponibles",
    "this-manufacturer-does-not-exist": "Este fabricante aún no está en el sistema. Se creará automáticamente para usted.",
    "this-vehicle-does-not-exist": "Este vehículo aún no está en el sistema. Se creará automáticamente para usted.",
    "required-to-complete-registration": "Para poder completar el registro es necesario un consentimiento",
    "email-is-already-used": "Este correo electrónico ya está en uso",
    "enter-valid-birthday-date": "Introduzca una fecha de nacimiento válida",
    "enter-valid-eu-number-format": "Utilice solo números en formato UE",
    "only-use-numbers-with-or": "Utilice solo números y '-' o '/'",
    "this-user-is-already-in-this-certification-authority": "Este usuario ya está en este organismo de certificación",
    "this-user-is-already-selected": "Este usuario ya está seleccionado",
    "this-user-is-already-in-a-company": "Este usuario ya está en una empresa",
    "the-document-could-not-be-loaded": "No se ha podido cargar el documento",
    continue: "Continuar",
    finish: "Listo",
    "cannot-add-users": "Los siguientes usuarios presentaban conflictos:",
    "add-course": "Añadir curso",
    "course-created-successfully": "Curso creado correctamente.",
    "course-updated-successfully": "Curso actualizado correctamente.",
    "mark-course-as-free": "Marcar el curso como gratuito",
    "scan-qr-code": "Escanear el código QR",
    "scan-to-join-course": "Escanee el código QR para unirse al curso",
    "remove-participant": "Quitar participante",
    "remove-participant-description": "¿Quitar a este participante del curso?",
    "user-is-already-participant": "Este usuario ya es participante del curso",
    "user-already-selected": "El usuario ya ha sido seleccionado",
    "delete-course": "Eliminar curso",
    "delete-course-description": "Este curso se eliminará. Se quitarán todos los participantes. ¿Continuar?",
    "course-removed": "El curso ha sido eliminado",
    "remove-efk-success": "Estado ESP retirado correctamente",
    "create-checklist": "Crear lista de comprobación",
    "make-efk-success": "Estado ESP asignado correctamente, se ha notificado al usuario",
    "resend-efk-success": "La invitación ESP se ha enviado de nuevo",
    "participants-added-successfully": "Participante añadido correctamente",
    "delete-document": "Eliminar documento",
    "delete-document-description": "¿Desea realmente eliminar este documento?",
    "delete-certificate-template": "Eliminar plantilla de certificado",
    "do-you-really-want-the-certificate-template-to": "¿Desea realmente la plantilla de certificado",
    "do-you-really-want-the-certification-authority-to": "¿Desea realmente el organismo de certificación",
    "delete-task": "Eliminar tarea",
    "do-you-really-want-to-delete-the-task": "¿Desea realmente eliminar la tarea «{name}»?",
    "delete-section": "Eliminar sección",
    "do-you-really-want-to-delete-the-section": "¿Desea realmente eliminar la sección «{name}»?",
    "course-content-saved-successfully": "Contenidos del curso guardados correctamente",
    "remove-certification-authority": "Quitar organismo de certificación",
    "do-you-really-want-to-remove-certification-authority": "¿Desea realmente quitar el organismo de certificación «{name}»?",
    "remove-course-content": "Quitar contenido del curso",
    "do-you-really-want-to-remove-course-content": "¿Desea realmente quitar el contenido del curso «{name}»?",
    "successfully-removed-course-content": "Contenido del curso eliminado correctamente",
    "language-already-exists-in-course": "El idioma seleccionado ya existe en este curso",
    "do-you-really-want-to-remove-course": "¿Desea realmente quitar el curso «{name}»?",
    "successfully-removed-course": "Curso eliminado correctamente",
    "publish-course-warning": "¿Está seguro de que desea publicar «{name}»? Tras la publicación, el curso ya no se puede editar hasta que se retire la publicación.",
    "unpublish-course-confirmation": "¿Está seguro de que desea retirar la publicación de «{name}»? Esto permite de nuevo realizar cambios.",
    "course-published-successfully": "Curso publicado correctamente",
    "course-unpublished-successfully": "Publicación del curso retirada correctamente",
    "successfully-enrolled-course": "Inscripción en el curso realizada correctamente",
    "remove-enrollment": "Quitar inscripción",
    "do-you-really-want-to-remove-enrollment": "¿Desea realmente quitar esta inscripción?",
    "successfully-removed-enrollment": "Inscripción eliminada correctamente",
  },
  tooltip: {
    "csv-export": "Exportación CSV",
    "add-user": "Añadir usuario",
    "invite-user": "Invitar usuario",
    "delete-user": "Eliminar usuario",
    "remove-user": "Quitar usuario",
    "edit-user": "Editar usuario",
    "view-user": "Ver usuario",
    "send-invitation-again": "Reenviar invitación",
    "send-activation-again": "Reenviar enlace de activación",
    "admin-cant-leave-company": "Como responsable de EVAL no puede abandonar la empresa",
    "leave-company": "Abandonar la empresa",
    "add-company": "Añadir empresa",
    "edit-company": "Editar empresa",
    "delete-company": "Eliminar empresa",
    "add-selected-users-to-company": "Añadir los usuarios seleccionados a una empresa",
    "add-selected-users-to-course": "Añadir los usuarios seleccionados a un curso",
    "add-vehicle": "Añadir vehículo",
    "show-vehicle": "Detalles del vehículo",
    "edit-vehicle": "Editar vehículo",
    "view-vehicle": "Ver vehículo",
    "accept-vehicle": "Incorporar el vehículo al sistema",
    "accept-vehicle-manufacturer": "Incorporar el fabricante del vehículo al sistema",
    "delete-vehicle": "Eliminar vehículo",
    "add-asset": "Añadir objeto",
    "add-gtp-class": "Añadir clase GTP",
    "edit-gtp-class": "Editar clase GTP",
    "delete-gtp-class": "Eliminar clase GTP",
    "add-asset-type": "Añadir tipo de objeto",
    "edit-asset-type": "Editar tipo de objeto",
    "delete-asset-type": "Eliminar tipo de objeto",
    "show-asset": "Detalles del objeto",
    "edit-asset": "Editar objeto",
    "delete-asset": "Eliminar objeto",
    "add-vehicle-manufacturer": "Añadir fabricante de vehículos",
    "edit-vehicle-manufacturer": "Editar fabricante de vehículos",
    "delete-vehicle-manufacturer": "Eliminar fabricante de vehículos",
    "vehicle-details-missing": "Faltan los detalles del vehículo",
    "remove-invitation": "Eliminar invitación",
    "send-missing-activations": "Enviar los correos de activación que faltan",
    "show-password": "Mostrar la contraseña",
    "hide-password": "Ocultar la contraseña",
    "create-report": "Crear informe de inspección",
    "select-for-report": "Seleccionar para el informe de inspección",
    "add-question": "Añadir campo",
    "remove-question": "Quitar campo",
    "create-certificates": "Crear certificados",
    "view-certificate": "Ver certificado",
    "delete-certificate": "Eliminar certificado",
    "view-report": "Ver informe de inspección",
    "delete-report": "Eliminar informe de inspección",
    "no-pdf-found": "No se ha encontrado ningún documento PDF",
    "add-report": "Añadir informe de inspección",
    "add-certificate": "Crear certificado",
    "no-certificate-to-create-report": "No tiene un certificado adecuado",
    "add-certification-authority": "Crear organismo de certificación",
    "edit-certification-authority": "Editar organismo de certificación",
    "delete-certification-authority": "Eliminar organismo de certificación",
    "add-certificate-template": "Crear plantilla de certificado",
    "edit-certificate-template": "Editar plantilla de certificado",
    "delete-certificate-template": "Eliminar plantilla de certificado",
    "add-report-template": "Añadir plantilla de informe",
    "edit-report-template": "Editar plantilla de informe",
    "delete-report-template": "Eliminar plantilla de informe",
    "view-certificate-training-data": "Ver material de formación",
    "save-sorting": "Guardar el orden",
    "mark-user": "Marcar usuario",
    "open-topic": "Ver tema",
    "edit-topic": "Editar tema",
    "delete-topic": "Eliminar tema",
    "edit-topic-answer": "Editar respuesta",
    "delete-topic-answer": "Eliminar respuesta",
    "select-all-users": "Marcar todos los usuarios",
    "add-course": "Añadir curso",
    "show-qr": "Mostrar el código QR",
    "edit-course": "Editar curso",
    "publish-course": "Publicar curso",
    "unpublish-course": "Retirar la publicación del curso",
    "remove-course": "Eliminar curso",
    "view-course": "Ver curso",
    "remove-efk": "Quitar estado ESP",
    "see-more": "Mostrar más",
  },
  phone: "Número de teléfono",
  address: "Dirección",
  birthday: "Fecha de nacimiento",
  "profile-picture": "Foto de perfil",
  userprofile: {
    "edit-profile": "Editar perfil",
    "public-profile": "Perfil público",
    "following-information": "La siguiente información se muestra en su perfil público",
    "notification-settings": "Si su empresa no envía notificaciones, este ajuste no tiene efecto",
  },
  "training-director": "Director de la formación",
  "participated-the-training": "ha participado en la formación ",
  "result-protocol": "Acta de resultados",
  measurements: "Valores medidos",
  freischaltung: "Consignación",
  isolationswiderstand: "Resistencia de aislamiento",
  potentialausgleich: "Conexión equipotencial",
  r: {
    "measuring-instrument-functionality": "Función del instrumento de medición",
    "positive-test-done": "Prueba positiva realizada",
    "voltage-between-hv-plus-and-chassis": "Tensión entre HV-más y chasis",
    "voltage-between-hv-plus-and-hv-minus": "Tensión entre HV-más y HV-menos",
    "voltage-between-hv-minus-and-chassis": "Tensión entre HV-menos y chasis",
    "the-tester-accepts-the-security-instructions": "El inspector confirma el cumplimiento de las indicaciones de seguridad del fabricante",
    "measuring-instrument-tested-at-reference-source": "¿Se ha comprobado la función del instrumento de medición en una fuente de referencia?",
    "measuring-instrument-tested": "¿Se ha comprobado la función del instrumento de medición?",
    "absence-of-voltage": "Ausencia de tensión",
    "absence-of-voltage-confirmed": "Ausencia de tensión constatada",
    voltage: "Tensión (V)",
    "used-voltage": "Tensión utilizada",
    "used-test-voltage": "Tensión de ensayo aplicada",
    "isolation-standard": "Valor nominal de la resistencia de aislamiento",
    "resistance-per-volt": "Resistencia por voltio",
    "hv-system-voltage": "Tensión de servicio AT / tensión del sistema AT",
    "isolation-resistance-between-hv-plus-and-chassis": "Resistencia de aislamiento entre HV-más y chasis",
    "isolation-resistance-between-hv-minus-and-chassis": "Resistencia de aislamiento entre HV-menos y chasis",
    "further-measurements-if-needed": "Otra medición si se desea",
    "test-current": "Corriente de ensayo (A)",
    "test-current-q": "Corriente de ensayo ...",
    "measuring-point": "Punto de medición",
    "measuring-point-chassis-vs": "Punto de medición chasis contra ...",
    "converter-housing": "Carcasa del inversor",
    "further-voltage-measurements-if-needed": "Otra medición de tensión si se desea",
    "measurements-ok-if-smaller-than-1-v": "Resultado de medición positivo si la tensión medida es inferior a 1 V",
    "visual-inspection": "Inspección visual",
    "cable-visual-inspection": "¿Se ha comprobado el cable en busca de daños visibles?",
    "connector-visual-inspection": "¿Se ha comprobado el conector en busca de daños visibles?",
    "isolation-test": "Ensayo de aislamiento",
    "cable-isolation-test": "¿Se ha comprobado la resistencia de aislamiento del cable?",
    "function-test": "Prueba de funcionamiento",
    "cable-function-test": "¿Se ha probado con éxito el proceso de carga?",
    "charging-cable-inspection-notes": "Otras comprobaciones si es necesario",
  },
  "new-report-no-id": "Nuevo informe de inspección",
  "required-field": "Este campo es obligatorio.",
  "fill-out-all-required-fields": "¡Rellene todos los campos obligatorios!",
  "valid-email-only": "Introduzca un correo electrónico válido.",
  "max-characters": "Máx. {count} caracteres",
  "certificate-notification": "Notificaciones de certificados",
  "certificate-notification-company": "Con esto se pueden desactivar las notificaciones para todos los empleados.",
  "calibration-notification": "Notificaciones de calibración",
  "calibration-notification-company": "Recordatorio antes de que caduque la calibración de un objeto.",
  "haynes-pro-vehicle-details": "Detalles del vehículo HaynesPro",
  "haynes-pro-no-details": "No hay detalles disponibles para el vehículo seleccionado.",
  "haynes-pro-hv-disconnect": "Sistema de alta tensión: dejar sin tensión",
  "vehicle-details-admin": "Detalles del vehículo",
  "haynes-pro-details": "Detalles HaynesPro",
  "haynes-pro-details-admin": "Detalles HaynesPro",
  "haynes-pro-details-not-found": "Lamentablemente no se ha encontrado nada para este vehículo.",
  "haynes-pro-load-error": "No se han podido cargar las instrucciones.",
  retry: "Intentar de nuevo",
  "haynes-pro-details-more-than-one-story": "Se ha encontrado más de una instrucción:",
  participants: "Participantes",
  "join-course": "Unirse al curso",
  "join-course-description": "¿Realmente unirse al curso? El formador del curso podrá gestionarle como participante.",
  "course-id-required": "¡El ID del curso es obligatorio para unirse a un curso!",
  "course-not-found": "Curso no encontrado",
  "error-loading-course": "Error al cargar el curso",
  "successfully-joined-course": "Se ha unido al curso correctamente",
  "error-joining-course": "Error al unirse, contacte con su formador.",
  refresh: "Recargar",
  "edit-course": "Editar curso",
  "make-efk": "Nombrar como ESP",
  "make-efk-description": "¿Nombrar a este usuario como ESP? Debe confirmarlo.",
  "resend-efk-invitation": "Reenviar la invitación ESP",
  "cancel-efk": "Cancelar el nombramiento ESP",
  efk: "ESP",
  "efk-position": "Puesto de ESP (electricista especializado)",
  "do-you-want-to-accept-efk-position": "¿Desea aceptar el puesto de ESP (electricista especializado)?",
  "do-you-want-to-refuse-efk-position": "¿Desea rechazar el puesto de ESP (electricista especializado)?",
  refuse: "Rechazar",
  "in-order-to-handle-efk-position": "Para poder aceptar el puesto de ESP (electricista especializado), debe estar ya registrado y con la sesión iniciada",
  "efk-position-accepted": "El puesto de ESP (electricista especializado) ha sido aceptado",
  "efk-position-refused": "El puesto de ESP (electricista especializado) ha sido rechazado",
  pending: "Pendiente",
  "remove-efk-description": "¿Desea retirar el puesto de ESP a este usuario?",
  "cancel-efk-description": "¿Desea realmente cancelar la invitación ESP para este usuario?",
  aborted: "Rechazado",
  checklists: "Listas de comprobación",
  "all-checklists": "Todas las listas de comprobación",
  manage: "Gestionar",
  "global-templates": "Plantillas globales",
  "global-template-authors": "Creadores globales de plantillas",
  "add-global-template-author": "Añadir creador global",
  "remove-global-template-author-confirm": "¿Realmente quitar como creador global de plantillas?",
  "report-templates": "Plantillas de informe",
  "report-template": "Plantilla de informe",
  "create-report-template": "Crear plantilla de informe",
  "edit-report-template": "Editar plantilla de informe",
  "delete-report-template": "Eliminar plantilla de informe",
  checklist: "Lista de comprobación",
  form: "Informe de inspección del vehículo",
  "basic-information": "Información básica",
  "object-data": "Datos del objeto",
  "object-data-configuration": "Configuración de los datos del objeto",
  "object-data-config-description": "Configure campos personalizados para la recogida de datos",
  "requires-vehicle": "Vinculado al vehículo",
  "assigned-vehicles": "Vehículos asignados",
  "assigned-vehicles-hint": "Vacío = se aplica a todos los vehículos",
  "assigned-vehicles-no-data": "Buscar vehículo …",
  "available-reports": "Informes disponibles",
  "create-report-now": "Crear informe",
  "vehicle-added-to-fleet": "El vehículo se encuentra ahora en sus vehículos de la empresa",
  "requires-asset": "Vinculado al objeto",
  "select-asset": "Seleccionar objeto",
  "field-name": "Nombre del campo",
  "display-name": "Nombre visible",
  "add-field": "Añadir campo",
  "questions-description": "Configure las preguntas para esta plantilla",
  "add-question": "Añadir pregunta",
  "example-images": "Imágenes de ejemplo",
  "upload-example-images": "Subir imágenes de ejemplo",
  "remove-image": "Quitar imagen",
  "images-uploaded-successfully": "Imágenes subidas correctamente",
  "error-uploading-images": "Error al subir las imágenes",
  "enable-validation": "Activar la validación",
  "validation-configuration": "Configuración de la validación",
  "expected-value": "Valor esperado",
  "at-least-one-language-required": "Se requiere al menos un idioma",
  "language-not-available": "Este idioma no existe",
  "multilingual-fields-info": "Campos multilingües: introduzca solo los idiomas para los que tenga traducciones. Se requiere al menos un idioma para los nombres y las preguntas.",
  operator: "Operador",
  "validation-value": "Valor de validación",
  equal: "Igual",
  "less-than": "Menor que",
  "greater-than": "Mayor que",
  "form-vehicle-info": "Esta es una plantilla de formulario. Los formularios se utilizan cuando se requiere un vehículo para el informe.",
  "checklist-object-data-info": "Esta es una plantilla de lista de comprobación. Las listas de comprobación utilizan la configuración de los datos del objeto en lugar de vehículos.",
  "protocols-title": "Informes",
  "evalus-reports": "Plantillas generales",
  "company-reports": "Informes de la empresa",
  "custom-templates": "Plantillas personalizadas",
  description: "Descripción",
  questions: "Preguntas de comprobación",
  question: "Pregunta",
  unit: "Unidad",
  boolean: "Sí/No",
  text: "Texto",
  "question-type-number": "Número",
  dropdown: "Selección",
  options: "Opciones",
  option: "Opción",
  "add-option": "Añadir opción",
  "expected-option": "Opción esperada",
  "dropdown-options-required": "Cada pregunta de selección necesita al menos una opción rellenada",
  "no-questions-yet": "Todavía no hay preguntas: añade la primera",
  "no-fields-yet": "Todavía no hay campos: añade el primero",
  "question-incomplete": "Esta pregunta aún está incompleta",
  "is-active": "Activo",
  "add-checklist": "Añadir lista de comprobación",
  "select-checklist-template": "Seleccione una plantilla de lista de comprobación",
  "no-checklist-templates-available": "No hay plantillas de lista de comprobación disponibles.",
  template: "Plantilla",
  "checklist-object-data": "Datos del informe",
  "report-template-saved": "La plantilla de informe se ha guardado correctamente",
  "new-checklist": "Nueva lista de comprobación",
  "view-checklist": "Mostrar lista de comprobación",
  "checklist-from": "Lista de comprobación del",
  "checklist-details": "Detalles de la lista de comprobación",
  field: "Campo",
  "checklist-created-successfully": "La lista de comprobación se ha creado correctamente",
  "error-creating-checklist": "Error al crear la lista de comprobación. Inténtelo de nuevo más tarde.",
  "tested-with-object": "Con el objeto",
  "required-asset-type": "Tipo de objeto necesario",
  "required-asset-type-hint": "Tipo de objeto con el que debe realizarse esta inspección del vehículo. Dejar vacío si no se necesita ningún objeto.",
  "can-calibrate": "Puede calibrar objetos",
  "calibratable-asset-type": "Tipo de objeto calibrable",
  "calibratable-asset-type-hint": "Solo los objetos de este tipo pueden calibrarse con esta lista de comprobación.",
  "calibration-validity-months": "Validez de la calibración (meses)",
  "calibration-validity-months-hint": "Si esta lista de comprobación se completa sin errores, el objeto vuelve a considerarse calibrado durante ese número de meses.",
  "select-required-asset": "Objeto utilizado",
  "asset-locked-calibration-expired": "Bloqueado: calibración caducada desde hace más de {days} días ({date})",
  "asset-calibration-expired-on": "Calibración caducada el {date}",
  "asset-restricted-hint": "Esta inspección solo puede realizarse con un objeto del tipo «{type}».",
  "asset-none-of-required-type": "Su empresa no tiene ningún objeto del tipo «{type}». Cree primero un objeto adecuado para poder realizar esta inspección.",
  "asset-all-expired": "En todos los objetos adecuados la calibración ha caducado hace más de {days} días, por lo que están bloqueados. Actualice la fecha de calibración en el objeto para continuar.",
  "asset-no-longer-allowed": "El objeto seleccionado ya no está permitido para esta inspección; posiblemente la calibración haya caducado hace demasiado tiempo. Compruebe la selección.",
  "add-users-to-course": "Añadir usuarios al curso",
  "selected-users": "Usuarios seleccionados",
  "start-date": "Fecha de inicio",
  "end-date": "Fecha de fin",
  "evalus-reports-info": "Aquí encontrará las «Plantillas generales». Los informes especiales puede encontrarlos, crearlos y gestionarlos en el menú «Listas de comprobación».",
  role: "Rol",
  eup: "EUP",
  "efk-tooltip": "Electricista especializado",
  "eup-tooltip": "Persona instruida en electrotecnia",
  "efk-pending": "Nombramiento pendiente",
  "strictly-required": "Obligatorio",
  "strictly-required-info": "Si está activado, el informe no se puede enviar si esta validación falla",
  "validation-failed": "Validación obligatoria fallida",
  "cannot-submit-invalid-required": "No se puede enviar: la validación requerida ha fallado",
  "create-new-entry": "Crear nueva entrada",
  "trainer-invalid-certificate": "El formador ya no tiene un certificado HV-4 o HV-L válido.",
  to: "hasta",
  "date-filter": "Filtro de fecha",
  "clear-filter": "Borrar filtro",
  "oldest-first": "Los más antiguos primero",
  "newest-first": "Los más recientes primero",
  "course-documents": "Anexos del curso",
  "select-documents": "Seleccionar documentos",
  "upload-documents": "Subir documentos",
  uploading: "Subir",
  "drag-and-drop-files": "Arrastre y suelte los archivos aquí",
  "drop-files-here": "Suelte los archivos aquí",
  "or-click-to-browse": "o haga clic para seleccionar archivos",
  "supported-formats": "Formatos compatibles",
  "existing-documents": "Documentos existentes",
  "documents-uploaded-successfully": "Documentos subidos correctamente",
  "document-deleted-successfully": "Documento eliminado correctamente",
  "no-course-documents-available": "Actualmente no está asignado a ningún curso o no se han facilitado documentos.",
  "more-files": "Más archivos",
  publicProfile: {
    status: {
      valid: "Válido",
      expiringSoon: "Caduca pronto",
      expired: "Caducado",
      certified: "Certificado",
      open: "Abierto",
      none: "Ninguna",
    },
    jobTitle: {
      efk: "HV-ESP",
      hv0: "Persona sensibilizada en AT",
      "hv1-3": "HV-EUP",
    },
    experienceStartDate: "Experiencia profesional desde",
    backgroundImage: "Imagen de fondo",
    totalCertificatesTitle: "Certificados",
    totalCertificatesDescription: "Número total de certificados",
    trainingLevelTitle: "Nivel de formación",
    trainingLevelDescription: "Nivel de formación más alto",
    practicalOperationsTitle: "Intervenciones prácticas",
    practicalOperationsDescription: "Actividades prácticas en sistemas de AT",
    vehicleModelsTitle: "Modelos de vehículos",
    vehicleModelsDescription: "Modelos de vehículos de AT atendidos",
    dashboardTitle: "Panel de experiencia en AT",
    dashboardSubtitle: "Estadísticas completas y experiencia en AT",
    certificationsTitle: "Certificaciones",
    certificationsSubtitle: "Resumen de la formación y el perfeccionamiento en el ámbito de la AT",
    instructor: "Instructor",
    issuedOn: "Emitido",
    validUntil: "Válido hasta",
    view: "Ver",
    loadMoreCertificates: "Cargar más certificados",
    hideCertificates: "Ocultar certificados",
    nav: {
      certifications: "Certificaciones",
      specialTraining: "Formaciones especiales",
      practicalExperiences: "Experiencias prácticas",
      vehicleCategories: "Categorías de vehículos",
    },
    specialTraining: {
      title1: "Especial",
      title2: "Formaciones",
      subtitle: "Cualificaciones adicionales y formaciones especiales",
    },
    practicalExperiences: {
      title1: "Prácticas",
      title2: "Experiencias",
      subtitle: "Experiencia práctica en sistemas de AT",
      freischaltungen: {
        title: "Consignaciones",
        description: "Consignaciones realizadas en sistemas de AT",
      },
      isolationstests: {
        title: "Mediciones de aislamiento",
        description: "Mediciones de resistencia de aislamiento realizadas",
      },
      potentialtests: {
        title: "Conexión equipotencial",
        description: "Mediciones de conexión equipotencial realizadas",
      },
      checklists: {
        title: "Listas de comprobación realizadas",
        description: "Listas de comprobación de seguridad completadas",
      },
      chargingCableChecks: {
        title: "Inspecciones de cables de carga",
        description: "Inspecciones de seguridad de cables certificadas HV-C",
      },
      issuedCertificates: {
        title: "Certificados emitidos",
        description: "Certificaciones emitidas como formador",
      },
    },
    vehicleCategories: {
      title1: "Categoría de vehículo ",
      title2: "Experiencias",
      subtitle: "Especializado en las siguientes categorías de vehículos y aplicaciones",
    },
    gtpCategories: {
      roadVehicles: "Vehículos de carretera",
      machines: "Maquinaria de construcción",
      racingVehicles: "Vehículos de carreras",
      aircraft: "Aeronaves",
      watercraft: "Embarcaciones",
      railVehicles: "Vehículos ferroviarios",
      developmentProduction: "I+D",
      aftersales: "Posventa",
    },
    footer: {
      qrTitle: "Acceso por código QR",
      qrSubtitle: "Escanee el código para acceder rápidamente al perfil",
      qrHint: "Escanear con la cámara",
      copyright: "© {year} Evalcard.com - Todos los derechos reservados",
      imprint: "Aviso legal",
      privacy: "Protección de datos",
    },
    shareProfile: "Compartir perfil",
    currentEmployer: "Empleador actual",
    linkCopied: "Enlace copiado correctamente al portapapeles",
    evalusProfile: "Perfil Evalus",
    sharingNotSuccessful: "El uso compartido no se ha realizado correctamente.",
    showInvalidCertificates: "Mostrar certificados caducados",
    hideInvalidCertificates: "Ocultar certificados caducados",
    invalidCertificatesHint: "Certificados ocultos que han sido sustituidos por otros más recientes",
    evalId: "N.º Eval-ID",
    ogCertifications: "Certificaciones",
    ogDescription: "Perfil público en EvalCard",
  },
  academy: {
    academy: "Academia",
    administration: "Administración",
    "my-orders": "Mis pedidos",
    "manage-courses": "Gestionar cursos",
    data: "Datos maestros",
    price: "Precio",
    "book-for-me": "Reservar para mí",
    "book-for-employee": "Reservar para empleados",
    passing_score: "Puntuación requerida en %",
    max_exam_attempts: "Número máximo de intentos de examen",
    max_exam_attempts_hint: "0 = ilimitado",
    exam_attempts_remaining: "Intentos restantes: {remaining} de {max}",
    exam_attempts_used: "Intentos: {used}",
    exam_attempts_limit_reached: "Se ha alcanzado el número máximo de intentos de examen",
    "edit-course": "@:edit-course",
    "all-languages-have-content": "Ya existen contenidos del curso para todos los idiomas.",
    "must-be-company-member-to-book": "Debe ser miembro de una empresa para poder reservar cursos.",
  },
  course: {
    course: "Curso",
    courses: "Cursos",
    "my-courses": "Mis cursos",
    "my-courses-view": "Resumen del curso",
    content: "Contenido del curso",
    "edit-content": "Editar contenido del curso",
    learn: "Aprendizaje",
    "learn-trail": "Ruta de aprendizaje",
    exam: "Examen",
    "exam-trail": "Ruta de examen",
    section: "Área",
    addLearnSection: "Añadir área de aprendizaje",
    addLearnTask: "Añadir tarea de aprendizaje",
    addExamSection: "Añadir área de examen",
    addExamTask: "Añadir pregunta de examen",
    sectionTitle: "Título del área",
    taskTitle: "Título de la tarea",
    questionTitle: "Título de la pregunta",
    enterSectionTitle: "Introducir título del área...",
    enterTaskTitle: "Introducir título de la tarea...",
    enterQuestionTitle: "Introducir título de la pregunta...",
    titleRequired: "El título es obligatorio",
    titleTooShort: "El título debe tener al menos 2 caracteres",
    itemAddedSuccessfully: "Elemento añadido correctamente",
    errorAddingItem: "Error al añadir el elemento",
    selectItemFromSidebar: "Seleccione un elemento de la barra lateral",
    task: "Tarea",
    question: "Pregunta",
    enterTitle: "Introducir título...",
    addItem: "Añadir elemento",
    "purchase-course": "Comprar curso",
    "purchase-initiated": "Compra iniciada correctamente",
    "learning-objectives": "Objetivos de aprendizaje",
    prerequisites: "Requisitos",
    syllabus: "Plan de estudios del curso",
    "learn-section": "Sección de aprendizaje",
    "exam-section": "Sección de examen",
    free: "Gratuito",
    booking: "Reserva",
    "purchase-date": "Reservado el",
    question_type: {
      question_type: "Tipo de pregunta",
      multiple_choice: "Opción múltiple",
      number: "Número",
      yes_no: "Sí / No",
    },
    operator: {
      operator: "Operador",
      equals: "Igual",
      notEquals: "Distinto",
      greaterThan: "Mayor que",
      lessThan: "Menor que",
      greaterThanOrEqual: "Mayor o igual",
      lessThanOrEqual: "Menor o igual",
    },
    correct_answer: "Respuesta correcta",
    yes: "Sí",
    no: "No",
    answer: "Respuesta",
    unit: "Unidad",
    select_course: "Seleccionar curso",
    select_language: "Seleccionar el idioma del curso",
    select_users: "Seleccionar usuario",
    error: {
      publish: "Error al publicar el curso",
      course_content_required: "Se requiere al menos un contenido del curso",
      certification_authority_required: "Se requiere al menos un organismo de certificación",
      certificate_template_missing: "Para cada contenido del curso debe seleccionarse una plantilla de certificado para todos los organismos de certificación",
      learn_section_task_required: "Cada área de aprendizaje debe contener al menos una tarea de aprendizaje",
      exam_section_task_required: "Cada área de examen debe contener al menos una pregunta de examen",
      monetization_required: "El curso debe estar marcado como gratuito o tener asignado un producto Paddle",
    },
    finish_course: "Finalizar el curso",
    completed_message: "Ha completado este curso correctamente.",
    linked_exam_section: "Sección de examen vinculada",
    linked_exam_section_hint: "Tras completar esta sección de aprendizaje se preguntará esta sección de examen",
    inline_exam_section: "Preguntas de examen",
    inline_exam_section_info: "Responda a todas las preguntas para continuar. Sus respuestas son definitivas.",
    question_progress: "Pregunta {current} de {total}",
    complete_exam_section: "Finalizar la sección",
    answered_during_learning: "Respondido durante el aprendizaje",
    section_already_answered: "Esta sección ya ha sido respondida",
    answers_are_final: "Las respuestas ya no se pueden modificar",
  },
  enrollment: {
    status: {
      in_progress: "Iniciado",
      not_started: "No iniciado",
      completed: "Completado",
    },
    enrolled_courses: "Cursos inscritos",
    enroll_course: "Inscribir en el curso",
    enrolled_on: "Inscrito el",
  },
  order: {
    order: "Pedido | Pedidos",
    my_orders: "Mis pedidos",
    view_order: "Ver",
    ordered_at: "Pedido el",
    status: {
      paid: "Pagado",
      pending: "Pendiente",
      failed: "Fallido",
      refunded: "Reembolsado",
      cancelled: "Cancelado",
    },
    payment: {
      paddle: "Paddle",
      request: "Solicitud",
      none: "Ninguna",
    },
    payment_method: "Método de pago",
    purchased_by: "Comprado por",
    purchased_for: "Comprado para",
    product: "Producto",
    "page-title": "Pedido",
    thank_you: "¡Gracias por su compra!",
    no_transaction_headline: "Pedido no encontrado",
    no_transaction_text: "Este pedido no existe o se ha producido un error.",
    back_to_courses: "Volver a los cursos",
    go_to_my_courses: "A mis cursos",
    purchase_now: "Comprar ahora",
    payment_pending: "Pago pendiente",
    payment_pending_text: "Su pedido se ha recibido, pero el pago aún no se ha completado. Complete el pago para acceder a su curso.",
    cancel_success: "Pedido cancelado correctamente",
    cancel_error: "Error al cancelar el pedido",
  },
  language: "Idioma",
  short_description: "Descripción breve",
  progress: "Progreso",
  total: "Total",
  complete_section: "Finalizar la sección",
  mark_task_complete: "Marcar la tarea como realizada",
  video_not_supported: "Su navegador no admite el elemento de vídeo.",
  overall_progress: "Progreso total",
  section_progress: "Progreso de la sección",
  task_completed: "Tarea completada correctamente",
  section_completed: "Sección completada correctamente",
  error_completing_task: "Error al finalizar la tarea",
  error_completing_section: "Error al finalizar la sección",
  next: "Continuar",
  finish_learning: "Finalizar el aprendizaje",
  start_learning: "Iniciar el aprendizaje",
  continue_learning: "Continuar el aprendizaje",
  take_exam_attempt: "Iniciar el examen",
  copy_course: "Copiar curso",
  select: "Seleccionar",
  exam_results: {
    congratulations: "¡Enhorabuena!",
    not_passed: "No aprobado",
    score: "Puntuación",
    you_passed: "¡Ha aprobado el examen!",
    need_score_to_pass: "Necesita {score} para aprobar. Inténtelo de nuevo.",
    score_details: "Detalles de la puntuación",
    question: "Pregunta",
    back_to_course: "Volver al curso",
    retake_exam: "Repetir el examen",
    view_certificate: "Mostrar certificado",
    download_certificate: "Descargar certificado",
  },
  exam_export: {
    export_pdf: "Exportar como PDF",
    title: "Resultado del examen",
    participant: "Participante",
    birthday: "Fecha de nacimiento",
    course: "Curso",
    attempt_number: "Intento",
    started_at: "Iniciado el",
    finished_at: "Completado el",
    overall_score: "Resultado total",
    passed: "Aprobado",
    failed: "No aprobado",
    given_answer: "Respuesta dada",
    correct_answer: "Respuesta correcta",
    no_answer: "Sin respuesta",
    yes: "Sí",
    no: "No",
    select_attempt: "Seleccionar intento",
    no_attempts: "No hay intentos completados",
    no_exam: "Este curso no tiene examen",
    generating: "Se está creando el PDF …",
    export_failed: "Exportación fallida",
  },
  "academy-assignment": {
    title: "Cursos de la academia asignados",
    "academy-course": "Curso de la academia",
    "available-for-regular-courses": "Seleccionable para cursos regulares",
    "for-regular-courses-badge": "Para cursos regulares",
    "cannot-publish-regular-course": "Este curso no se puede publicar porque está destinado a cursos regulares",
    language: "Idioma",
    "select-course-first": "Seleccione primero un curso de la academia",
    "no-matching-courses": "No hay cursos de la academia adecuados disponibles (no publicados, aprobados, nivel adecuado)",
    type: "Tipo",
    "type-entry": "Prueba de acceso",
    "type-intermediate": "Prueba intermedia",
    "type-final": "Examen final",
    assign: "Asignar curso de la academia",
    remove: "Quitar asignación",
    "remove-warning": "Si se quita la asignación, se eliminarán las inscripciones y los resultados de examen de los participantes para este curso de la academia. ¿Continuar?",
    "assigned-successfully": "Curso de la academia asignado correctamente",
    "removed-successfully": "Asignación eliminada correctamente",
    results: "Resultados de los participantes",
    participant: "Participante",
    score: "Resultado",
    status: "Estado",
    attempts: "Intento",
    passed: "Aprobado",
    failed: "No aprobado",
    "in-progress": "En curso",
    "not-started": "No iniciado",
  },
  exam_interface: {
    sections: "Secciones",
    overall_progress: "Progreso total",
    questions: "Preguntas",
    progress: "Progreso",
    section: "Sección",
    question_of: "Pregunta {current} de {total}",
    answered: "Respondido",
    not_answered: "Sin responder",
    previous: "Atrás",
    next: "Continuar",
    submit_exam: "Finalizar el examen",
    quick_navigation: "Navegación rápida",
    submit_exam_confirm: "¿Entregar el examen?",
    submit_exam_message: "¿Está seguro de que desea entregar su examen?",
    answered_count: "Ha respondido <strong>{answered}</strong> de <strong>{total}</strong> preguntas.",
    cannot_change_warning: "Tras la entrega ya no puede modificar sus respuestas.",
    loading: "Cargando",
    error: "Error",
    back: "Atrás",
    select_certificate_authority: "Seleccionar organismo de certificación",
    select_authority_message: "Seleccione un organismo de certificación para emitir su certificado.",
    no_authorities_available: "No hay organismos de certificación disponibles para este curso.",
    certificate_issued: "¡Certificado emitido correctamente!",
    error_issuing_certificate: "Error al emitir el certificado",
    exam_submitted_successfully: "¡Examen entregado correctamente!",
    exam_submit_error: "Error al entregar el examen",
  },
  could_not_add_section: "No se ha podido añadir la sección",
  successfully_added_section: "Sección añadida correctamente",
  could_not_add_task: "No se ha podido añadir la tarea",
  successfully_added_task: "Tarea añadida correctamente",
  could_not_remove_attachment: "No se ha podido quitar el adjunto",
  successfully_removed_attachment: "Adjunto eliminado correctamente",
  could_not_remove_task: "No se ha podido quitar la tarea",
  successfully_removed_task: "Tarea eliminada correctamente",
  could_not_remove_section: "No se ha podido quitar la sección",
  successfully_removed_section: "Sección eliminada correctamente",
  "default-academy-issuer": "Emisor predeterminado de certificados de la academia",
  "default-academy-issuer-hint": "Emite automáticamente los certificados de los cursos de la academia completados, salvo que el participante ya tenga un certificado de otro organismo asignado al curso. Solo puede haber un organismo predeterminado.",
  "academy-documents": "Documentos de la academia",
  "back-to-documents": "Volver a mis documentos",
  "completed-on": "Completado el",
  "my-documents-academy": "Mis documentos de la academia",
  "from-task": "De la tarea",
  "from-section": "De la sección",
  "no-documents-in-course": "No hay documentos disponibles en este curso",
  "unknown-course": "Curso desconocido",
  "error-loading-documents": "Error al cargar los documentos",
}
